module.exports = __webpack_public_path__ + "static/media/line-size-5.ddb3b522.svg";